import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { withTranslation } from 'react-i18next'

import './EventFilter.css'

class EventFilter extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isOpen: false,
            isSelected: false,
            selectedInterval: ''
        }

        this.onDropdownClick = this.onDropdownClick.bind(this)
        this.onDropdownToggle = this.onDropdownToggle.bind(this)
    }

    onDropdownClick(e) {
        const selectedInterval = e.target.textContent

        this.setState({ isSelected: true, selectedInterval, isOpen: false })

        this.props.onEventIntervalSelection(e)
    }

    onDropdownToggle() {
        this.setState(prevState => ({ isOpen: !prevState.isOpen }))
    }

    render() {
        const { isOpen, isSelected, selectedInterval } = this.state
        const { t } = this.props

        const positionClass = isOpen ? 'open' : 'close'
        const selectedClass = isSelected ? 'selected' : ''

        return (
            <div className="event-filter">
                <div
                    className={`event-filter__default-option event-filter__default-option--${selectedClass}`}
                    onClick={this.onDropdownToggle}
                >
                    <div
                        className={`event-filter__default-option__text event-filter__default-option__text--${positionClass}`}
                    >
                        {t('eventDetails.filterDropdown.title')}
                    </div>
                    {isSelected && (
                        <div className="event-filter__default-option__option-text">
                            {selectedInterval}
                        </div>
                    )}
                </div>
                {isOpen && (
                    <div className="event-filter__options">
                        <div
                            className="event-filter__options__item"
                            onClick={this.onDropdownClick}
                            data-position={0}
                        >
                            {t('eventDetails.filterDropdown')[0]}
                        </div>
                        <div
                            className="event-filter__options__item"
                            onClick={this.onDropdownClick}
                            data-position={1}
                        >
                            {t('eventDetails.filterDropdown')[1]}
                        </div>
                        <div
                            className="event-filter__options__item"
                            onClick={this.onDropdownClick}
                            data-position={2}
                        >
                            {t('eventDetails.filterDropdown')[2]}
                        </div>
                    </div>
                )}
            </div>
        )
    }
}

EventFilter.propTypes = {
    onEventIntervalSelection: PropTypes.func
}

export { EventFilter }
export default withTranslation()(EventFilter)
